import { render, staticRenderFns } from "./common-poster-exhibitor.vue?vue&type=template&id=244418ef&scoped=true&"
import script from "./common-poster-exhibitor.vue?vue&type=script&lang=js&"
export * from "./common-poster-exhibitor.vue?vue&type=script&lang=js&"
import style0 from "./common-poster-exhibitor.vue?vue&type=style&index=0&id=244418ef&lang=scss&scoped=true&"
import style1 from "./common-poster-exhibitor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244418ef",
  null
  
)

export default component.exports